module.exports = __webpack_public_path__ + "c12c446988bea7c8199750b1fa21ff59.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/middown-s.png
// module id = 3166
// module chunks = 0